import React from 'react'
import { Trans } from 'react-i18next'

export function LicenseQuotaNotification({ data }: { data: any }) {
  const messages: JSX.Element[] = []

  Object.keys(data).forEach((serverId: string) => {
    const scansData = data[serverId]
    const value = typeof scansData['amount'] !== 'undefined' ? scansData['amount'] : scansData['percents']
    const valueParam = { value } as any
    const serverParam = { server: serverId } as any

    const message =
      typeof scansData['amount'] !== 'undefined' ? (
        <Trans i18nKey="license-quota-amount-notification">
          License daily quota is running low for <strong>{serverParam}</strong> server. Only
          <strong>{valueParam}</strong> scans is left
        </Trans>
      ) : (
        <Trans i18nKey="license-quota-percents-notification">
          License daily quota is running low for <strong>{serverParam}</strong> server. It's reached about
          <strong>{valueParam}%</strong> of daily limit
        </Trans>
      )

    messages.push(message)
  })

  return (
    <div className="alert alert-warning" style={{ whiteSpace: 'break-spaces' }}>
      {messages.length == 1 ? (
        messages
      ) : (
        <ul>
          {messages.map((message, idx) => (
            <li key={idx}>{message}</li>
          ))}
        </ul>
      )}
    </div>
  )
}
